import { XCircleIcon } from "@heroicons/react/20/solid";

export default function ErrorAlert({ text }: { text: string }) {
	return (
		<div className="eF-rounded-md eF-bg-red-50 eF-p-4 eF-mt-2">
			<div className="eF-flex">
				<div className="eF-flex-shrink-0">
					<XCircleIcon
						className="eF-h-5 w-5 eF-text-red-400"
						aria-hidden="true"
					/>
				</div>
				<div className="eF-ml-3">
					<h3 className="eF-text-sm !eF-my-0 eF-font-medium eF-text-red-800">
						{text}
					</h3>
				</div>
			</div>
		</div>
	);
}
